import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ServiceBase } from '../infrastructure/service-base';
import { BackendService } from './backend.service';

// eslint-disable-next-line no-shadow
export enum ServiceStatus {
  error,
  working
}

export interface Service {
  status: ServiceStatus;
}

export type ServiceList = Array<Service>;

@Injectable({
  providedIn: 'root'
})
export class ServicesService extends ServiceBase {

  public constructor(
    backend: BackendService
  ) {
    super(backend);
  }

  protected get object(): string {
    return 'services';
  }

  public getList(): Observable<ServiceList> {
    return this.makeGetCall('list');
  }

  public refreshDatabase(): Observable<boolean> {
    return this.makeGetCall<boolean>('refresh_db');
  }
}
